"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const create_icon_1 = require("../utils/create-icon");
exports.CopyIcon = (0, create_icon_1.createIcon)({
    displayName: "Copy",
    path: [
        (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "m21.21,22.53H6.08c-.77,0-1.4-.63-1.4-1.4V5.99c0-.77.63-1.4,1.4-1.4h15.14c.77,0,1.4.63,1.4,1.4v15.14c0,.77-.63,1.4-1.4,1.4ZM6.08,5.4c-.33,0-.59.27-.59.59v15.14c0,.33.27.59.59.59h15.14c.33,0,.59-.27.59-.59V5.99c0-.33-.27-.59-.59-.59H6.08Z" }),
        (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "m18.02,1.93H2.88c-.77,0-1.4.63-1.4,1.4v15.13c0,.77.63,1.4,1.4,1.4h.84v-.81h-.84c-.32,0-.59-.26-.59-.59V3.33c0-.33.27-.59.59-.59h15.14c.33,0,.59.26.59.59v.31h.81v-.31c0-.77-.63-1.4-1.4-1.4Z" }),
    ],
});
